import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  html {
    font-size: var(--dynamic-font-size, 15px);
  }

  @media screen and (min-width: 7680px) {
    html { 
      font-size: 60px;
    }
  }

  @media screen and (min-width: 5120px) and (max-width: 7679px) {
    html { 
      font-size: 40px;
    }
  }

   @media screen and (min-width: 3840px) and (max-width: 5119px){
    html { 
      font-size: 30px;
    }
  }

  @media screen and (min-width: 3200px) and (max-width: 3839px) {
    html { 
      font-size: 25px;
    }
  }

  @media screen and (min-width: 2560px) and (max-width: 3199px) {
    html { 
      font-size: 24px;
    }
  }

  @media screen and (min-width: 2048px) and (max-width: 2559px) { 
    html { 
      font-size: 18px;
    }
  }

  @media screen and (min-width: 1920px) and (max-width: 2047px) { 
    html {
      font-size: 15px;
    }
  }

  @media screen and (min-width: 1600px) and (max-width: 1919px) { 
      font-size: 13px;
  }  

  @media screen and (min-width: 1280px) and (max-width: 1599px) { 
    html {
      font-size: 12px;
    }
  }

  @media screen and (min-width: 960px) and (max-width: 1279px) {
    html {
      font-size: 10px;
    }
  }  

  @media screen and (min-width: 854px) and (max-width: 959px) { 
    html {
      font-size: 8px;
    }
  }

  @media screen and (min-width: 640px) and (max-width: 853px) {  
    html {
      font-size: 6px;
    }
  }

  @media screen and (min-width: 423px) and (max-width: 639px) {
    html {  
      font-size: 4px;
    }
  }
    

  @media screen and (min-width: 257px) and (max-width: 422px) {
    html { 
      font-size: 3px;
    }
  }

  @media screen and (max-width: 256px) {
    html { 
      font-size: 2px;
    } 
  }

    body {
      overflow: hidden;
      height: 100vh;
      font-family: "Montserrat", sans-serif;
    }

    * {
      margin: 0;
      padding: 0;
      font-family: "Montserrat", sans-serif;
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }

    .clear-default-arrows-in-carousel {
      :where(.css-dev-only-do-not-override-1uga22k).ant-carousel
        .slick-prev::after {
        transform: rotate(-45deg);

        display: none;
      }

      :where(.css-dev-only-do-not-override-1uga22k).ant-carousel
        .slick-next::after {
        transform: rotate(135deg);

        display: none;
      }
    }

    .ant-modal  {
      height: fit-content !important;
    }

    .ant-card, .ant-modal {
        border-radius: 0.5rem;
    }

    a {
          transition: none;
      text-decoration: none;
      color: inherit;

      &:visited,
      &:active {
        text-decoration: none;
        color: inherit;
      }
  }
`;
